'use strict';

var React = require("react");
var Icons$AlgoVis = require("./Icons.bs.js");
var Pages$AlgoVis = require("./Pages.bs.js");
var Components$AlgoVis = require("./Components.bs.js");

function App(Props) {
  return React.createElement(React.Fragment, undefined, React.createElement("header", undefined, React.createElement(Components$AlgoVis.ColorModeToggle.make, {}), React.createElement("a", {
                      "aria-label": "Visit GitHub repository",
                      href: "https://github.com/nimobeeren/algo-vis"
                    }, React.createElement(Icons$AlgoVis.GitHub.make, {}))), React.createElement(Pages$AlgoVis.Home.make, {}));
}

var make = App;

exports.make = make;
/* react Not a pure module */
